import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PaymentsSrSearchResultInfoComponent } from './sr-search-result-info.component';

/**
 * Exports UI components and modules for payments common
 */
@NgModule({
  imports: [CommonModule],
  declarations: [PaymentsSrSearchResultInfoComponent],
  exports: [PaymentsSrSearchResultInfoComponent],
})
export class PaymentsSrSearchResultInfoModule {}
